module.exports = __webpack_public_path__ + "assets/text.48ab7c8c.svg";